import {Client} from "@stomp/stompjs";
import env from './env'

const prefix = (location.hostname.split('.').length > 2 && location.hostname.split('.')[0].includes('stage')) ? `${location.hostname.split('.')[0]}_` : '';
const server = env.server === 'prod' ? '' : prefix;
const queues = {
    tracking: `/queue/${server}tracking`,
    session: `/queue/${server}session`,
    result: `/queue/${server}user_results`,
    answers: `/queue/${server}user_answers`,
    prebid: `/queue/${server}prebid_collector`,
    ads_loaded: `/queue/${server}ads_loaded`,
    taboola_spend: `/queue/${server}taboola_spend`,
}

const eventTypeMap = {
    page_load:      'tracking',
    session_start:  'session',
    user_result:    'result',
    page_advance:   'tracking',
    user_answer:    'answers',
    bids_collected: 'prebid',
    ads_loaded:     'ads_loaded',
    taboola_spend:  'taboola_spend',
};

const send = (events) => {
    try {
        let client = new Client({
            brokerURL: env.url,
            reconnectDelay: 0,
            heartbeatIncoming: 0,
            heartbeatOutgoing: 0,
        });

        client.activate();
        client.onConnect = function() {
            events.forEach((e) => {
                client.publish({
                    destination: queues[eventTypeMap[e.type]],
                    headers: { persistent: true },
                    body: !!e.plain_data ? JSON.stringify(e.data) : JSON.stringify(e),
                })
            })
            client.deactivate();
        }
    } catch (e) {
        console.debug(e);
    }
}

export { send };
